import React, { FC, useState } from 'react';

// Shared UI Library Components
import { Paginator } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './counsellors-list.scss';

// Components
import { CounsellorsCard } from '../counsellors-card/counsellors-card';

// Models
import { ICounsellor } from '../../../../interfaces/counsellors.interfaces';

type TCounsellorsListProps = {
  counsellors: ICounsellor[];
  total: number;
  stripeConnected: boolean;
  pageChange?: (page: number) => void
}

export const CounsellorsList: FC<TCounsellorsListProps> = (
  { counsellors, total, stripeConnected, pageChange = () => {} }: TCounsellorsListProps
) => {

  const [current, setCurrent] = useState<number>(1);

  const firstColumnList = counsellors.filter((_, idx) => idx % 2 === 0);
  const secondColumnList = counsellors.filter((_, idx) => idx % 2 !== 0);

  const onPageChangeHandler = (page: number): void => {
    pageChange(page);
    setCurrent(page);
  }

  const onResetListHandler = (): void => {
    onPageChangeHandler(1);
  }

  return (
    <div className="counsellors-list">
      <div className="counsellors-list--body">
        <div className="body-column desktop-items">
          { firstColumnList.map((counsellor) =>
            <CounsellorsCard key={ counsellor.id }
                             stripeConnected={ stripeConnected }
                             counsellor={ counsellor }
                             resetList={ onResetListHandler }
            />) }
        </div>
        <div className="body-column desktop-items">
          { secondColumnList.map((counsellor) =>
            <CounsellorsCard key={ counsellor.id }
                             stripeConnected={ stripeConnected }
                             counsellor={ counsellor }
                             resetList={ onResetListHandler }
            />) }
        </div>
        <div className="body-column mobile-items">
          { counsellors.map((counsellor) =>
            <CounsellorsCard key={ counsellor.id }
                             stripeConnected={ stripeConnected }
                             counsellor={ counsellor }
                             resetList={ onResetListHandler }
            />) }
        </div>
      </div>
      { total > 10 && <div className="counsellors-list--pagination">
        <Paginator current={ current } totalItems={ total } pageChange={ onPageChangeHandler }/>
      </div> }
    </div>
  );
}
